import { render, staticRenderFns } from "./SdsSection8JSOHForm.vue?vue&type=template&id=5204d318"
import script from "./SdsSection8JSOHForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection8JSOHForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports